import { get } from 'svelte/store';
import { planning } from '../../../stores/store';
import { api } from '../../../stores/api';
import { ScenarioApi } from './ScenarioApi';
import { _ } from 'svelte-i18n';
import { openModal } from 'svelte-modals';
import ModalSetRouteStartTime from '../Modals/ModalSetRouteStartTime.svelte';
import ModalStartPlanning from '../Modals/ModalStartPlanning.svelte';

export function runOnlyWithStartPlanning(
    fn: Function,
    fnNegative: Function | null = null
): boolean {
    if (!get(planning).planningStarted) {
        planning.set({ ...get(planning), planningStarted: true });
        return true;

        // if (!confirm(get(_)('Planning not started yet. Do you want to start planning?'))) return false;
        openModal(ModalStartPlanning, {
            onClick: () => {
                if (get(planning).currentScenarioId !== null) {
                    // @ts-ignore get(planning).currentScenarioId is not null here
                    ScenarioApi.setStartPlanning(get(api), get(planning).currentScenarioId, true)
                        .then(() => {
                            planning.set({ ...get(planning), planningStarted: true });
                            fn();
                        })
                        .catch(err => {
                            alert(get(_)('Nie udało się rozpoczać planowania. Spróbuj ponownie.'));
                            if (typeof fnNegative == 'function') {
                                fnNegative();
                            }
                        });
                    return true;
                } else {
                    alert(get(_)('Nie wybrano scenariusza'));
                    if (typeof fnNegative == 'function') {
                        fnNegative();
                    }
                    return false;
                }
            },
            onCancel: () => {
                if (typeof fnNegative == 'function') {
                    fnNegative();
                }
            },
        });
        return true;
    } else {
        fn();
        return true;
    }
}
